import React from 'react';

const UsFlag = ({ className }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true" focusable="false">
    <rect width="24" height="16" fill="#B22234" />
    <g fill="#FFFFFF">
      <rect y="1.23" width="24" height="1.23" />
      <rect y="3.69" width="24" height="1.23" />
      <rect y="6.15" width="24" height="1.23" />
      <rect y="8.62" width="24" height="1.23" />
      <rect y="11.08" width="24" height="1.23" />
      <rect y="13.54" width="24" height="1.23" />
    </g>
    <rect width="10" height="8.62" fill="#3C3B6E" />
  </svg>
);

export default UsFlag;
